"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ConfigurationError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.default = ConfigurationError;
//# sourceMappingURL=ConfigurationError.js.map